import {
  FAQS,
  AnalyticsHeader,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const gwinnettstripers_pass: TTeamConfig = {
  TEAM_SCHEMA: "gwinnettstripers_pass",
  TEAM_FULL_NAME: "Gwinnett Stripers",
  BROWSER_TITLE: "Stripers Summer Pass",
  CLIENT_ID: "8f53ebdb774b.seasonshare.gwinnettstripers-dbh.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#0d223f",
    COLORS_SECONDARY: "#73aa4f",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    ANALYTICS_HEADER: AnalyticsHeader,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/gwinnettstripers/",
    IS_INTERCOM_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#73aa4f",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/Gwinnett-Stripers-Logo.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/DBH%20Pass%20Assets/Gwinnett%20Stripers/SUMMER%20PASS_1920x450%20BACKGROUND.jpg",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
